import { PersonalInfoFormValues } from 'types/personalInfoTypes';

export const createPersonalInfoFormValues = (): PersonalInfoFormValues => ({
  firstName: '',
  middleName: '',
  lastName: '',
  phone: '',
  position: '',
  partnerCode: ['', '', '', ''],
});
